import { downloadCSV } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";

const exporter = (customerPassportsPhysical) => {
  const data = customerPassportsPhysical.map((customerPassportPhysical) => ({
    id: customerPassportPhysical.id,
    numero_passaporte: customerPassportPhysical.customer_passport,
    usuario: customerPassportPhysical.customer_name,
    retirado_em: customerPassportPhysical.collection_point_passport_name,
    entregue_por: customerPassportPhysical.collection_point_passport_admin_name,
    data_retirada: customerPassportPhysical.date_withdrawal_format,
    criado_em: customerPassportPhysical.created_at_format,
  }));
  const csv = convertToCSV({
    data,
    fields: ["id", "numero_passaporte", "usuario", "retirado_em", "entregue_por",
             "data_retirada", "criado_em"],
  });
  downloadCSV(csv, "customerPassportsPhysical");
};

export default exporter;
